import { updateObject } from "../../shared/utility";
import { marketingConstants } from "../../constants";

// getting the default actions name from defined constants via decomposition
const {
  GET_REPORTS_DATA,
  GET_PARTNER_CODES,
  GET_PARTNER_CODE_BY_ID,
  GET_ALL_ACTIVE_PARTNER_CODES,
} = marketingConstants;

const initialState = {
  data: {},
  total: 7,
  pageSize: 5,
  currentPage: 1,
  numberOfPages: 2,
  reportsData: [],
  partnerCodes: [],
  allPartnerCodes: [],
  partnerCodeById: {},
  isSubmitButtonDisabled: false,
};

// manupilating the state based on actions and returning the state
export const marketing = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTNER_CODES:
      return updateObject(state, {
        partnerCodes: action?.data?.items,
      });
    case GET_PARTNER_CODE_BY_ID:
      return updateObject(state, {
        partnerCodeById: action?.data?.items,
      });
    case GET_REPORTS_DATA:
      return updateObject(state, {
        reportsData: action?.data,
      });
    case GET_ALL_ACTIVE_PARTNER_CODES:
      return updateObject(state, {
        allPartnerCodes: action?.data?.items,
      });
    default:
      return state;
  }
};
